import LocalizedStrings from 'react-native-localization';
import en from './en.json';

const Strings = new LocalizedStrings({
  en,
});

export default Strings;
